import { useMutation, useQuery } from '@apollo/client'
import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { DEMANDE_UPDATE } from '../../../apollo/mutation/demande.mutation'
import { SINISTRE_BY_ID } from '../../../apollo/query/demande.query'
import { D4_Demande, D4_Demande_Set_Input, D4_Fn_View_Demande, D4_Lot } from '../../../types'
import SelectCoproprietaires from '../../SelectCoproprietaires'

const SelectLese = ({ demande }: { demande: D4_Fn_View_Demande }) => {
  const [updateDemande] = useMutation<{}, { id: number; data: D4_Demande_Set_Input }>(DEMANDE_UPDATE)
  const [origine, setOrigine] = useState(-1)

  const { data, loading } = useQuery<{ demande: D4_Demande }, { id: number }>(SINISTRE_BY_ID, {
    variables: { id: demande.id },
  })

  const handleSelect = async (value: number) => {
    setOrigine(value)
    await updateDemande({
      variables: {
        id: demande.id,
        data: { typelesesinistre: value },
      },
    })
  }

  const copaLese = async (id: number, lot: D4_Lot) => {
    await updateDemande({
      variables: {
        id: demande.id,
        data: { coproprietairelese_id: lot.lot_coproprietaire?.coproprietaire.id },
      },
    })
  }

  useEffect(() => {
    if (data?.demande?.typelesesinistre) {
      setOrigine(data.demande.typelesesinistre)
    }
  }, [data])

  if (loading) {
    return null
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Select
        listHeight={800}
        style={{ minWidth: '240px' }}
        placeholder="Lésé"
        onChange={handleSelect}
        defaultValue={data?.demande?.typelesesinistre}
      >
        <Select.Option value={0}>Copropriété</Select.Option>
        <Select.Option value={1}>Copropriétaire</Select.Option>
        <Select.Option value={2}>Locataire</Select.Option>
        <Select.Option value={3}>Autre</Select.Option>
      </Select>
      {origine === 1 && (
        <SelectCoproprietaires
          placeholder="Copropriétaire"
          style={{ minWidth: '240px' }}
          trigramme={demande.copropriete?.trigramme ?? ''}
          onChange={copaLese}
          defaultValue={data?.demande?.coproprietairelese_id}
        />
      )}
    </div>
  )
}

export default SelectLese
